import { oz } from '@weft/utils';
import { invoicesByReviewStatusSchema } from './invoice-by-review-status-schema';

export const UpdateInvoicesReviewStatusRequestSchema = oz.object({
  invoicesByNewStatus: invoicesByReviewStatusSchema,
}).openapi('UpdateInvoicesReviewStatusRequest');

export type UpdateInvoicesReviewStatusRequestPayload = oz.infer<typeof UpdateInvoicesReviewStatusRequestSchema>;